export default __webpack_public_path__ + "static/media/slider-bg2.a1eb46f9.jpg";